module.exports = __webpack_public_path__ + "images/google_account_selection-00f6e127299213716f690b3d381a16fb.png";